<template>
    <button
        @click="callback($event)"
        class="button"
        :class="{
            button_big: big,
            button_border: border,
            button_disabled: disabled,
        }"
    >
        <slot />
    </button>
</template>

<script>
export default {
    props: {
        big: {
            type: Boolean,
            default: false,
        },
        border: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        callback: function (e) {
            this.$emit("click", e);
        },
    },
};
</script>

<style lang="scss" scoped>
.button {
    font-family: Montserrat;
    padding: 10px 20px;
    background-color: #6fda44;
    border-radius: 5px;
    font-style: normal;
    font-weight: 700;
    font-size: 15px;
    text-align: center;
    line-height: normal;
    color: #ffffff;
    transition: background-color 0.2s ease 0s, transform 0.1s ease;
    cursor: pointer;
    &:active {
        transform: scale(0.96);
    }
    @media (any-hover: hover) {
        &:hover {
            background-color: #66c142;
        }
    }
    &_big {
        padding: 16px 20px;
    }
    &_border {
        color: #263238;
        border: 1px solid #263238;
        background-color: #fbfbfb;

        @media (any-hover: hover) {
            &:hover {
                background-color: #e0dfdf;
            }
        }
    }
    &._fw {
        width: 100%;
    }
}
</style>
